<template>
    <Protocols
        :title="$gettext('Protokoly pro lineární obsah')"
        :protocols="protocols"
        :protocol-ids="entity.protocol_order_linear_content"
        :isEditable="isEditable"
        @addProtocol="onAddProtocol"
        @removeProtocol="onRemoveProtocol"
        @sortProtocols="onSortProtocols"
    />
</template>

<script>

import Protocols from "./Protocols";

export default {
    name: "LinearProtocols",
    components: {Protocols},
    props: {
        entity: Object,
        protocols: Array,
        isEditable: Boolean
    },
    methods: {
        onAddProtocol(newIdProtocol) {
            this.entity['protocol_order_linear_content'] = [...this.entity['protocol_order_linear_content'], newIdProtocol];

            if (!(newIdProtocol in this.entity['protocols'])) {
                if (!(newIdProtocol in this.entity['protocols'])) {
                    this.$emit('addProtocol', newIdProtocol);
                }
            }
        },
        onRemoveProtocol(deletedIdProtocol) {
            this.entity['protocol_order_linear_content'] = this.entity['protocol_order_linear_content'].filter((idProtocol) => idProtocol != deletedIdProtocol);
        },
        onSortProtocols(sortedProtocolIds) {
            this.entity['protocol_order_linear_content'] = sortedProtocolIds;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/forms/LinearProtocols.vue